import Flickity from 'flickity';
import select from 'dom-select';
import throttle from 'lodash.throttle';
import 'flickity-imagesloaded';
import 'flickity-fade';

export default (el) => {
  const ui = {
    el,
    tabsList: select('.tabs__tab-list', el),
    tabs: select.all('.tabs__tab', el),
    panelList: select('.tabs__panel-list', el),
    panels: select.all('.tabs__panel', el)
  };

  // initialize carousel
  let flkty;

  const state = {
    isSelectVariant: ui.el.classList.contains('select-tabs')
  };

  const onLoad = () => {
    // initialize "carousel"
    flkty = new Flickity(ui.panelList, {
      adaptiveHeight: true,
      autoPlay: false,
      fade: true,
      imagesLoaded: true,
      pageDots: false,
      prevNextButtons: false,
      draggable: false
    });

    // set index to 0
    flkty.select(0);

    if (ui.tabs[0]) {
      ui.tabs[0].classList.add('is-active');
    }

    // settle is a Flickity event fired once slide change completes
    flkty.on('settle', () => {
      flkty.resize();
    });

    flkty.on('select', (index) => {
      if (ui.tabs[0]) {
        ui.tabs.forEach((t) => {
          t.classList.remove('is-active');
        });

        ui.tabs[index].classList.add('is-active');
      }
    });
  };

  const selectTabByIndex = (index) => {
    flkty.select(index);
    ui.panels[index].classList.add('is-active');
    ui.panels[index].blur();
  };

  const addEventListeners = () => {
    window.addEventListener('resize', throttle(() => {
      flkty.resize();
    },
    250,
    {
      trailing: true,
      leading: true
    }));

    // default pattern
    if (!state.isSelectVariant) {
      // each tab gets click event
      ui.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          selectTabByIndex(index);
        });
      });
    } else {
      // listen for outside new CustomEvent('openAtIndex', { ... })
      ui.el.addEventListener('openAtIndex', (e) => {
        // get index of ID-ed panel
        const targetPanel = select(`#${e.detail.value}`, ui.panelList);
        const index = ui.panels.indexOf(targetPanel);

        flkty.select(index);
        ui.tabs[index].classList.add('is-active');
      });
    }
  };

  const init = () => {
    onLoad();
    addEventListeners();
  };

  init();
};
